<template>
  <div class="footer-link-column-2 footer-link-column caption">
    <div class="column-header">
      <div class="header-icon">
        <img src="../assets/icons/arrow-right-black-extended.svg" alt="">
      </div>
      <div class="overline">{{$t('footer.links')}}</div>
    </div>
    <div @click="$emit('openPopup', 'ARRIVAL')" class="info-row">{{$t('footer.arrival')}}</div>
    <div @click="$emit('openPopup', 'MEDIA')" class="info-row">{{$t('footer.media')}}</div>
<!--    <div @click="$emit('openPopup', 'NEWSLETTER')" class="info-row">{{$t('footer.newsletter')}}</div>-->
    <div @click="$emit('openPopup', 'JOBS')" class="info-row">{{$t('footer.jobs')}}</div>
  </div>
</template>

<script>
export default {
  name: 'FooterLinkColumn2',

}
</script>

<style lang="scss">
@import "FooterLinkColumn2.scss";
</style>
